import { createUseStyles } from 'react-jss'
import YoutubeVideo from '@/components/__commons/YoutubeVideo'
import BannerLite from '@/components/BannerLite'
import style from './style'

const useStyles = createUseStyles(style)

function MediaBlock({ media_type, youtube_id, poster_video, image }) {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      {media_type === 'youtube' && youtube_id ? (
        <div className={classes.videoSection}>
          <YoutubeVideo
            videoId={youtube_id}
            poster={poster_video.url}
          />
        </div>
      ) : (
        <div className={classes.heroImg}>
          <BannerLite
            data={{
              image: image.url,
              imageAlt: image.alt,
              imageTitle: image.title,
            }}
            noObserver
          />
        </div>
      )}
    </div>
  )
}

export default MediaBlock
